import React from "react";

import { NOT_ACCESSIBLE } from "common/constants";
import { transformViewDate } from "utils/date-utils";

import useStyles from "./styles";

interface IProps {
  title: string;
  deadlineDate: string;
}

const FormHeader = (props: IProps) => {
  const { title, deadlineDate } = props;
  const deadlineDateContent = deadlineDate
    ? transformViewDate(deadlineDate)
    : NOT_ACCESSIBLE;

  const classes = useStyles();

  return (
    <div className={classes.pageHeaderInfo}>
      <span className={classes.pageHeaderInfoName}>{title}</span>
      <span className={classes.pageHeaderInfoDeadline}>
        {`Deadline: ${deadlineDateContent}`}
      </span>
    </div>
  );
};

export default React.memo(FormHeader);
